import { useEffect, useState } from "react";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

export const useCreateServiceStepTwoDictionaries = () => {
  const [serviceBaseSelect, setServiceBaseSelect] = useState([]);
  const [serviceTasks, setServiceTasks] = useState([]);
  const [serviceProblems, setServiceProblems] = useState([]);
  const [additionalInfoSelect, setAdditionalInfoSelect] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const serviceBaseFetch = GlobalAuthFetch({
        path: "/dictionary/serviceBase/fieldName",
      });

      const tasksTypeFetch = GlobalAuthFetch({
        path: "/dictionary/tasksDictionary/fieldName",
      });

      const additionalInfoFetch = GlobalAuthFetch({
        path: "/dictionary/additionalInfo/fieldName",
      });

      const problemsTypeFetch = GlobalAuthFetch({
        path: "/dictionary/problemDescriptionsDictionary/fieldName",
      });

      const [
        serviceBasePayload,
        tasksTypePayload,
        problemsTypePayload,
        additionalInfoPayload,
      ] = await Promise.all([
        serviceBaseFetch,
        tasksTypeFetch,
        problemsTypeFetch,
        additionalInfoFetch,
      ]);

      setServiceBaseSelect(
        serviceBasePayload?.payload?.data?.dictionaryEntries
          ?.sort((a, b) => a.entryName.localeCompare(b.entryName))
          ?.map((el) => ({
            name: el.entryName,
            value: el.uuid,
          })) || [],
      );

      setServiceTasks(
        tasksTypePayload?.payload?.data?.dictionaryEntries
          ?.sort((a, b) => a.entryName.localeCompare(b.entryName))
          ?.map((item) => ({
            value: item.uuid,
            label: item.entryName,
            ...item,
          })) || [],
      );

      setServiceProblems(
        problemsTypePayload?.payload?.data?.dictionaryEntries
          ?.sort((a, b) => a.entryName.localeCompare(b.entryName))
          ?.map((item) => ({
            value: item.uuid,
            label: item.entryName,
            ...item,
          })) || [],
      );

      setAdditionalInfoSelect(
        additionalInfoPayload?.payload?.data?.dictionaryEntries
          ?.sort((a, b) => a.entryName.localeCompare(b.entryName))
          ?.map((item) => ({
            value: item.uuid,
            label: item.entryName,
            ...item,
          })) || [],
      );
    };

    fetchData();
  }, []);

  return {
    serviceBaseSelect,
    serviceTasks,
    serviceProblems,
    additionalInfoSelect,
  };
};
